export class JsonHelper {
  static parseToJson(value: any): any {
    if (typeof value === 'string') {
      try {
        return JSON.parse(value);
      } catch {
        // Not valid JSON, keep as string
        return value
      }
    }
    return value;
  }
}
